/** Marks editor/preview-injected stylesheets so serializers can strip them —
 * they are render-only chrome and must never reach saved HTML. */
export const EDITOR_STYLE_ATTRIBUTE = "data-ht-editor-style";

/**
 * Append a stylesheet to a preview document, returning a cleanup that removes
 * it — the standard way effects layer mode-specific styles (hover rings,
 * cursor, edit-mode overrides) onto live iframe documents.
 */
export function injectDocumentStyle(doc: Document, css: string): () => void {
  const style = doc.createElement("style");
  style.setAttribute(EDITOR_STYLE_ATTRIBUTE, "");
  style.textContent = css;
  doc.head.appendChild(style);
  return () => style.remove();
}
